import { IdentityProvidersState } from "@idw-types/state/identity-providers-state";
import { getIdentityProvidersState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getIdentityProvidersReferenceDataState = createSelector(getIdentityProvidersState, (state: IdentityProvidersState) => {
    return state.referenceData;
});

export const getIdentityProvidersDataState = createSelector(getIdentityProvidersState, (state: IdentityProvidersState) => {
    return {
        isLoadingIdentityProviderConfigurations: state.identityProviderConfigurations.isLoading,
        identityProviderConfigurations: state.identityProviderConfigurations.identityProviderConfigurations
    };
});